<!-- =========================================================================================
    File Name: V2HeaderActions.vue
    Description: .
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="relative">
      <button class="v2_header_action" @click="openActions">
        <vs-icon
          class="text-sm"
          icon-pack="feather"
          icon="icon-user"
          color="white"
        ></vs-icon>
      </button>

      <v2-popover ref="popover">
        <ul class="v2_header_actions">
          <li class="v2_header_actions_item">
            <button
              class="v2_header_actions_btn"
              @click="openChangeCompanyDialog"
              v-if="companyList.length > 1"
            >
              <feather-icon
                icon="RefreshCwIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>

              Empresas
            </button>
          </li>

          <li class="v2_header_actions_item">
            <button class="v2_header_actions_btn" @click="signOut()">
              <feather-icon
                icon="LogOutIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>

              Sair
            </button>
          </li>
        </ul>
      </v2-popover>
    </div>

    <v2-dialog
      ref="dialog"
      title="Lista de Empresas"
      v-if="companyList.length > 1"
    >
      <div class="v2_company_dialog">
        <h2 class="v2_company_dialog_title">Selecione a empresa desejada:</h2>

        <ul class="v2_company_dialog_list">
          <li
            class="v2_company_dialog_list_item"
            :key="company.id_usuario"
            v-for="company of companyList"
          >
            <input
              type="radio"
              :id="company.id_usuario"
              name="company"
              :value="company.id_empresa"
              @change="selectCompany"
              :checked="company.id_empresa === selectedCompanyId"
            />
            <label :for="company.id_usuario"
              >{{ company.nome }} - {{ company.id_empresa }}</label
            >
          </li>
        </ul>
      </div>
    </v2-dialog>
  </div>
</template>

<script>
import V2Popover from './V2Popover.vue';
import V2Dialog from './V2Dialog.vue';
import { clearCacheStorage } from '../../services/cacheService';

export default {
  components: {
    V2Popover,
    V2Dialog,
  },

  methods: {
    openActions(event) {
      this.$refs.popover.openPopover(event);
    },

    openChangeCompanyDialog() {
      this.$refs.dialog.openDialog();
    },

    selectCompany(event) {
      const { _value: value } = event.target;

      const selectedId = Number(value);

      const company = this.companyList.find(
        (company) => company.id_empresa === selectedId,
      );

      if (company) {
        localStorage.removeItem('idEmpresa');
        this.selectedCompanyId = selectedId;
        this.$refs.dialog.closeDialog();
        this.$refs.popover.closePopover();
        this.$store.dispatch('updateSelectedEmpresa', company);
        this.$router.push('/login-empresa');
      }
    },

    signOut() {
      localStorage.removeItem('user-token');
      localStorage.removeItem('p');
      localStorage.removeItem('listEmpresas');
      localStorage.removeItem('rotaEntrada');
      clearCacheStorage();
      this.$router.push('/Login');
    },
  },

  data() {
    return {
      companyList: this.$store.state.listEmpresa || [],
      selectedCompanyId: this.$store.state.currentEmpresa,
    };
  },
};
</script>

<style lang="scss">
.v2_header_action {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 24px;
  background-color: #0c90cf;
  border: 0;
  cursor: pointer;
}

.v2_header_actions {
  width: 166px;
  height: 100%;
  padding: 8px;
}

.v2_header_actions_item {
  width: 100%;
  height: 100%;
}

.v2_header_actions_btn {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px 12px 16px;
  border-radius: 8px;
  background-color: transparent;
  outline: transparent;
  border: 0;
  color: #2e2e2e;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.25px;
  cursor: pointer;

  &:hover {
    background-color: #d9d9d9;
  }
}

.v2_company_dialog {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.v2_company_dialog_title {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1;
  color: #434343;
}

.v2_company_dialog_list_item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
}

.v2_company_dialog_list_item input[type='radio'] {
  visibility: hidden;
  position: absolute;
  width: 0;
  height: 0;
}

.v2_company_dialog_list_item label {
  position: relative;
  padding-left: 32px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #6d6d6d;
}

.v2_company_dialog_list_item label::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 16px;
  height: 16px;
  border: 2px solid #6d6d6d;
  border-radius: 50%;
  background-color: white;
}

.v2_company_dialog_list_item label::after {
  content: '';
  position: absolute;
  left: 5px;
  top: 5px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #0f4173;
  transform: scale(0);
}

.v2_company_dialog_list_item input[type='radio']:checked + label::after {
  transform: scale(1);
}

.v2_company_dialog_list_item input[type='radio']:checked + label::before {
  border-color: #0f4173;
}
</style>
